import React from 'react'
import { Trans } from 'react-i18next'

/** Tariffs step component */
export const TariffsStep: React.FC = () => {
  return <Trans i18nKey="emobility.tour.tariffs" components={{ strong: <strong /> }} />
}
